import { css } from '@emotion/react';
import { PhoneTree } from '@weave/schema-gen-ts/dist/shared/phone/v1/phonerecordext/message.pb';
import { Icon } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { Text, Truncated } from '@frontend/design-system';
import { DialOptionBadge } from './dial-option-badge';
import { FallbackBadge } from './fallback-badge';

export const PhoneTreePreview = ({ ivrEvents = [], onClick }: { ivrEvents?: PhoneTree[]; onClick?: () => void }) => {
  const displayIVREvents = (ivrEvents.length > 0 && [ivrEvents[ivrEvents.length - 1]]) || [];

  return (
    <div
      css={css`
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: ${theme.spacing(0.5)};
        ${onClick ? 'cursor: pointer;' : 'cursor: default'}
      `}
      onClick={onClick}
    >
      {displayIVREvents.map((event, index) => (
        <>
          <div
            key={index}
            css={css`
              display: flex;
              align-items: center;
              gap: ${theme.spacing(0.5)};
            `}
          >
            <div
              css={css`
                max-width: 100px;
              `}
            >
              <Truncated as={Text} size='medium' color='default'>
                {event.phoneTreeName ?? ''}
              </Truncated>
            </div>
            {!!event.dialOption && (
              <>
                <Icon name='caret-right-tiny' />
                {event.dialOption === 'FALLBACK' ? (
                  <FallbackBadge value={event.dialOption} />
                ) : (
                  <DialOptionBadge displayValue={event.dialOption} />
                )}
              </>
            )}
          </div>
        </>
      ))}
    </div>
  );
};
